import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';
import { HTTP_NO_CONTENT } from 'constants/httpStatusCodes';
import {
  SEND_EMAILS_ERROR,
  SEND_EMAILS_START,
  SEND_EMAILS_SUCCESS,
} from 'constants/action-types/communication/sendEmails';
import getAllEmails from './getAllEmails';

export default data => dispatch =>
  dispatch(
    apiAction({
      url: '/users/notifications/emails',
      method: 'POST',
      data,
      API_REQUEST_START: SEND_EMAILS_START,
      API_REQUEST_SUCCESS: SEND_EMAILS_SUCCESS,
      API_REQUEST_FAILURE: SEND_EMAILS_ERROR,
      onStart: () => dispatch({ type: SEND_EMAILS_START }),
      callbackOnSuccess: ({ message, status }) => {
        if (status === HTTP_NO_CONTENT) {
          return notification({
            message: 'No user found.',
            status: 'warn',
          });
        }
        notification({ message });
        return getAllEmails()(dispatch);
      },
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
